interface Dimensions {
  width: number;
  height: number;
}

type Callback = (dimensions: Dimensions) => void;

let callbacks: Callback[] = [];

export function addCallback(cb: Callback) {
  callbacks.push(cb);
  return cb;
}

export function removeCallback(cb: Callback) {
  callbacks = callbacks.filter(c => c !== cb);
}

export const observer = new ResizeObserver(entries => {
  for (const entry of entries) {
    const dimensions: Dimensions = (() => {
      if (entry.contentBoxSize) {
        const contentBoxSize = Array.isArray(entry.contentBoxSize)
          ? entry.contentBoxSize[0]
          : entry.contentBoxSize;

        return {
          width: contentBoxSize.inlineSize,
          height: contentBoxSize.blockSize,
        };
      }

      return {
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      };
    })();

    callbacks.forEach(cp => {
      cp(dimensions);
    });
  }
});

export default {
  addCallback,
  removeCallback,
  observer,
};
